<template>
  <div class="page-content ride-ordering">
    <div class="row">
      <div
        v-if="hasCustomerInfo"
        class="col-sm-6 col-12"
      >
        <div
          v-if="!rideFormType"
          class="d-flex justify-content-around mt-4 mb-4"
        >
          <p-button
            type="purple"
            round
            class="btn-large"
            @click="rideFormType = 'order'"
          >
            Order a Ride Now
          </p-button>

          <p-button
            type="yellow"
            round
            class="btn-large"
            @click="rideFormType = 'schedule'"
          >
            Schedule for the future
          </p-button>
        </div>

        <template v-else>
          <el-radio-group v-model="rideFormType">
            <el-radio-button label="order">
              Order a Ride Now
            </el-radio-button>
            <el-radio-button label="schedule">
              Schedule a Ride in the Future
            </el-radio-button>
          </el-radio-group>

          <basic-ride-limit-value-upgrade-banner class="mt-3 mb-3" />

          <order-ride
            v-if="rideFormType === 'order'"
            @change-ride-form="rideFormType = 'schedule'"
          />
          <schedule-ride v-if="rideFormType === 'schedule'" />
        </template>
      </div>
      <h4
        v-else
        class="warning-message text-center mt-0 col-sm-6 col-12"
      >
        Please pull up customer info on RightPanel to order/schedule a ride.
      </h4>
      <div class="col-sm-6 col-12">
        <cancel-ride />
        <cancel-auto-retry-ride />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, nextTick, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';

import OrderRide from '@/components/Main/Shared/OrderRide/OrderRide.vue';
import ScheduleRide from '@/components/Main/Shared/OrderRide/ScheduleRide.vue';
import BasicRideLimitValueUpgradeBanner from '@/components/Main/Operator/RideOrdering/BasicRideLimitValueUpgradeBanner.vue';
import CancelRide from '@/components/Main/Operator/RideOrdering/CancelRide.vue';
import CancelAutoRetryRide from '@/components/Main/Operator/RideOrdering/CancelAutoRetryRide.vue';

export default {
  name: 'PartnerRideOrdering',

  components: {
    OrderRide,
    BasicRideLimitValueUpgradeBanner,
    CancelRide,
    CancelAutoRetryRide,
    ScheduleRide,
  },

  setup: () => {
    const route = useRoute();
    const { customerInfo } = useCustomer();

    const rideFormType = ref('');

    const hasCustomerInfo = computed(() => !!customerInfo.value?.id);

    onMounted(async () => {
      const hash = route.hash;

      await nextTick();
      util.moveScrollComponent(hash);

      rideFormType.value = (route.query.rideFormType as string) || '';
    });

    return {
      rideFormType,
      hasCustomerInfo,
    };
  },
};
</script>

<style lang="scss">
.ride-ordering {
  .el-radio-group {
    display: flex;

    .el-radio-button {
      flex: 1;

      .el-radio-button__inner {
        width: 100%;
      }
    }
  }

  button.btn-large {
    padding: 10px 20px !important;
    font-size: 20px !important;
  }
}
</style>
